export const BASE_URL="https://apps.bitopibd.com/PMSCoreAPI"
//export const BASE_URL="https://localhost:7011"